import { theme } from '../../content/settings/settings.json'

export const colorOptions = ['default', ...theme.colorVariables.map(color => color.variable)]
